<div class="row">
	<div *ngFor="let tag of tags; let i = index" class="col-lg-4">
		<kt-tag-card
			(btnClick)="tagClick.emit($event)"
			[status]="dynamicBtnStyle(i)"
			[tag]="tag"
		></kt-tag-card>
	</div>
</div>
